<template>
    <h2 class="h2">{{ t('step2.title') }}</h2>
    <DSInput
        v-model="date"
        :label="t('step2.date')"
        readonly
    />
    <DSCombobox
        v-model="order.data.value.time"
        class="time"
        :label="t('step2.time')"
        :help-text="t('dsform.required')"
        :options="timeOptions"
    />
    <DSInput
        v-model="order.data.value.comments"
        :label="t('step2.additionalInfo')"
    />
    <div class="menu">
        <div
            v-for="(product, index) in products"
            :key="`product-${index}`"
            class="product"
        >
            <h3 class="h5">{{ product.product }}</h3>
            <span class="price">{{ $cms.formatPrice(product.price) }}</span>
            <DSNumber
                v-model="order.data.value.products[index]"
                class="amount"
                type="number"
                :max-value="200"
            />
        </div>
        <div class="sum">
            <div>
                <h3 class="h5">{{ t('step2.sum') }}</h3>
                <span v-if="total.amount">
                    {{ t('step2.pcsSummary', total) }}
                </span>
            </div>
            <span class="price">
                {{ $cms.formatPrice(total.price) }}
            </span>
        </div>
    </div>
</template>
<script setup>
import { computed, inject, useI18n } from '#imports';

const order = inject('order');
const products = inject('products');
const total = inject('total');
const date = inject('date');

const timeOptions = computed(() => {
    const startTime = 0;
    const endTime = 24;
    const times = [];

    for (let index = startTime; index < endTime; index++) {
        times.push(
            { value: `${index}:00`, label: `${index}:00` },
            { value: `${index}:15`, label: `${index}:15` },
            { value: `${index}:30`, label: `${index}:30` },
            { value: `${index}:45`, label: `${index}:45` },
        );
    }

    return times;
});

const { t } = useI18n({
    useScope: 'global',
    messages: {
        'fi-FI': {
            step2: {
                title: 'Valitse munkkipaketti ja noutoaika',
                date: 'Päivämäärä',
                time: 'Noutoaika',
                sum: 'Yhteensä',
                pcsSummary: '{amount}kpl ({pcs} munkkia)',
                additionalInfo: 'Lisätoiveita / muita huomioita',
                productAmountError: 'Valitse vähintään yksi tuote',
            },
        },
    },
});
</script>
<style scoped>
.h3 {
  margin-top: 0;
  margin-bottom: 0;
}

.price {
  font-size: 1.75rem;
  font-weight: 800;
}

.time {
  margin-bottom: 0.75rem;
}

.product,
.sum {
  border: 1px solid var(--color-base-grey-200);
  margin: 1rem 0;
  display: grid;
  grid-template-columns: 3fr 2fr 2fr;
  padding: 1rem;
  align-items: center;
}
.product .h5,
.sum .h5 {
  margin: 0.25rem 0;
}

.sum .price {
  grid-column-start: 3;
  justify-self: end;
}

@media (max-width: 991px) {
  .product {
    grid-template-columns: 1fr 1fr;
  }
  .product .h5 {
    grid-column-end: span 2;
  }
  .product .ds-number {
    justify-self: end;
  }
}
</style>
